import loadable from '@wix/yoshi-flow-editor/loadable';

export const MyPosts = loadable(
  () => import(/* webpackChunkName: "MyPosts" */ './MyPosts'),
  {
    resolveComponent: (component) => component.MyPosts,
  },
);
